module.exports = __webpack_public_path__ + "img/if_6.d6234562.png";